// Main Cashier Getters

export const getMainCashierList = state => {
  return state.mainCashierList
}

export const getMainCashierInfo = state => {
  return state.mainCashierInfo
}
